<template>
  <v-dialog v-model="value" @click:outside="close" persistent max-width="550">
    <v-tabs v-model="tab" v-if="creating && !isOnlyCategory">
      <v-tab href="#product">{{ $t("product") }}</v-tab>
      <v-tab href="#category">{{ $t("category") }}</v-tab>
      <v-spacer />
      <v-btn fab small text @click="$emit('closeDialog')">
        <v-icon size="20">mdi-close</v-icon>
      </v-btn>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item value="product">
        <v-card>
          <v-card-title>
            {{ creating ? $t("productCreate") : $t("editGroup") }}
          </v-card-title>
          <v-card-text>
            <validation-observer ref="productFormObs" v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(apply)">
                <div class="row">
                  <label class="col-md-5 pt-5 primary--text"
                    >{{ $t("productCategory") }}*</label
                  >
                  <search-input
                    :get-item-promise="
                      (name) => $store.dispatch('getProductTypes', { name })
                    "
                    :items.sync="types"
                    v-model="formData.typeId"
                    class="col-md-7 user_input"
                    :placeholder="$t('livingRoomFurniture')"
                  ></search-input>
                </div>
                <div class="row">
                  <label class="col-md-5 pt-5 primary--text"
                    >{{ $t("productGroup") }}*</label
                  >
                  <search-input
                    :name="$t('productGroup')"
                    v-model="formData.product_group_id"
                    :get-item-promise="
                      (name) => $store.dispatch('getProductGroups', { name })
                    "
                    :items.sync="groups"
                    rules="required"
                    class="col-md-7 pt-0 user_input"
                  >
                  </search-input>
                </div>
                <!--                <div class="row">-->
                <!--                  <label class="col-md-5 pt-5 primary&#45;&#45;text">{{ $t('packageType') }}*</label>-->
                <!--                  <custom-select-->
                <!--                    :name="$t('packageType')"-->
                <!--                    v-model="formData.packageType"-->
                <!--                    :items="PACKAGE_TYPES"-->
                <!--                    item-text="text"-->
                <!--                    item-value="value"-->
                <!--                    rules="required"-->
                <!--                    class="col-md-7 pt-0 user_input">-->
                <!--                  </custom-select>-->
                <!--                </div>-->
                <div class="row">
                  <label class="col-md-5 pt-5 primary--text"
                    >{{ $t("nameOfProduct") }}*</label
                  >
                  <custom-input-text
                    v-model="formData.name"
                    rules="required"
                    class="col-md-7 pt-0 user_input"
                  >
                  </custom-input-text>
                </div>
                <div class="row">
                  <label class="col-md-5 pt-5 primary--text"
                    >{{ $t("measure") }}*</label
                  >
                  <custom-select
                    :name="$t('measure')"
                    multiple
                    :items="unitTypes"
                    :item-text="`name_${$i18n.locale}`"
                    v-model="formData.unitTypeIds"
                    rules="required"
                    class="col-md-7 pt-0 user_input"
                  >
                  </custom-select>
                </div>
                <div class="text-right">
                  <v-btn :loading="loading" color="primary" type="submit">
                    {{ $t("save") }}
                  </v-btn>
                </div>
              </form>
            </validation-observer>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item value="category">
        <v-card>
          <v-card-title>
            {{ creating ? $t("create") : $t("editGroup") }}
            <v-spacer />
            <v-btn fab small text @click="$emit('closeDialog')">
              <v-icon size="20">mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <validation-observer
              v-slot="{ handleSubmit }"
              ref="categoryFormObs"
            >
              <form @submit.prevent="handleSubmit(apply)">
                <div class="row">
                  <label class="col-md-5 pt-4 primary--text">{{
                    $t("parentNameCategories")
                  }}</label>
                  <custom-select
                    rules="required"
                    :items="types"
                    v-model="formData.parentId"
                    class="col-md-7 user_input"
                    :placeholder="$t('parentNameCategories')"
                  ></custom-select>
                </div>
                <div class="row">
                  <label class="col-md-5 pt-4 primary--text"
                    >{{ $t("newCategoryName") }}-UZ*</label
                  >
                  <custom-input-text
                    rules="required"
                    v-model="formData.name_uz"
                    class="col-md-7 pt-0 user_input"
                    :placeholder="$t('newCategoryName')"
                  ></custom-input-text>
                </div>
                <div class="row">
                  <label class="col-md-5 pt-4 primary--text"
                    >{{ $t("newCategoryName") }}-RU</label
                  >
                  <custom-input-text
                    v-model="formData.name_ru"
                    class="col-md-7 pt-0 user_input"
                    :placeholder="$t('newCategoryName')"
                  ></custom-input-text>
                </div>
                <div class="row">
                  <label class="col-md-5 pt-4 primary--text"
                    >{{ $t("newCategoryName") }}-EN</label
                  >
                  <custom-input-text
                    v-model="formData.name_en"
                    class="col-md-7 pt-0 user_input"
                    :placeholder="$t('newCategoryName')"
                  ></custom-input-text>
                </div>
                <div class="text-right mt-3">
                  <v-btn :loading="loading" color="primary" type="submit">
                    {{ $t("save") }}
                  </v-btn>
                </div>
              </form>
            </validation-observer>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-dialog>
</template>

<script>
import { categoryKey, productKey, PACKAGE_TYPES } from "@/utils/constants";
import SearchInput from "@/plugins/Vuetify/components/SearchInput";

export default {
  components: { SearchInput },
  props: {
    value: {
      type: Boolean,
    },
    isProductForm: {
      type: Boolean,
    },
    isOnlyCategory: {
      type: Boolean,
    },
    types: {
      type: Array,
      default: () => [],
    },
    groups: {
      type: Array,
      default: () => [],
    },
    unitTypes: {
      type: Array,
      default: () => [],
    },
    formData: {
      type: Object,
    },
  },
  watch: {
    tab() {
      const { categoryFormObs, productFormObs } = this.$refs;
      if (categoryFormObs) categoryFormObs.reset();
      if (productFormObs) productFormObs.reset();
    },
    value(val) {
      if (!val) {
        const { categoryFormObs, productFormObs } = this.$refs;
        this.$emit("update:formData", {
          name: "",
          id: null,
          typeId: null,
          parentId: null,
        });
        this.$emit("update:isOnlyCategory", false);
        if (categoryFormObs) categoryFormObs.reset();
        if (productFormObs) productFormObs.reset();
      }
    },
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
    async apply() {
      this.loading = true;
      let data;
      try {
        if (this.isProductForm) {
          data = await this.submitProductForm();
        } else {
          data = await this.submitTypeForm();
        }
        this.$emit("save", {
          type: this.isProductForm ? productKey : categoryKey,
          data,
          isCreated: this.creating,
        });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },
    async submitProductForm() {
      try {
        const { name, typeId, id, product_group_id, unitTypeIds, packageType } =
          this.formData;
        const formData = new FormData();
        if (id) {
          formData.append("id", id);
        }
        if (typeId) {
          formData.append("product_type_id", typeId);
        }
        if (product_group_id) {
          formData.append("product_group_id", product_group_id);
        }
        if (packageType) {
          formData.append("packageType", packageType);
        }
        if (name) {
          formData.append("name", name);
        }
        unitTypeIds.forEach((unitType) => {
          formData.append("unitTypeIds", unitType);
        });

        const {
          data: { data },
        } = await this.$http.post("product/save", formData);
        return data;
      } catch (e) {
        this.setResponseError({ error: e });
        throw new Error(e);
      }
    },
    async submitTypeForm() {
      try {
        let { name_uz, name_en, name_ru, parentId, id } = this.formData;
        if (!name_en.length) {
          name_en = name_uz;
        }
        if (!name_ru.length) {
          name_ru = name_uz;
        }
        let formData = {
          parentId: parentId,
          name_uz,
          name_en,
          name_ru,
        };
        if (id) {
          formData["id"] = id;
        }
        const {
          data: { data },
        } = await this.$http.post("product-type/save", formData);
        data.children = [];
        return data;
      } catch (e) {
        this.setResponseError({ error: e });
        throw new Error(e);
      }
    },
  },
  data() {
    return {
      loading: false,
      PACKAGE_TYPES: PACKAGE_TYPES.map((item) => {
        return {
          text: this.$t(`productPackageType.${item}`),
          value: item,
        };
      }),
    };
  },
  computed: {
    tab: {
      get() {
        return !this.isOnlyCategory && this.isProductForm
          ? "product"
          : "category";
      },
      set(val) {
        if (val === "product") {
          this.$emit("update:isProductForm", true);
        } else {
          this.$emit("update:isProductForm", false);
        }
      },
    },
    creating() {
      return !this.formData.id;
    },
  },
};
</script>
